import { render, staticRenderFns } from "./UsersAssignMaps.vue?vue&type=template&id=484e6fc2&scoped=true"
import script from "./UsersAssignMaps.vue?vue&type=script&lang=js"
export * from "./UsersAssignMaps.vue?vue&type=script&lang=js"
import style0 from "./UsersAssignMaps.vue?vue&type=style&index=0&id=484e6fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e6fc2",
  null
  
)

export default component.exports